export default {
  token: state => state.user.token,
  logoInfo: state => state.user.logoInfo,
  userInfo: state => state.user.userInfo,
  routers: state => state.user.routers,
}
